// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__oFamJ","search":"Settings_search__1sPYQ","filter":"Settings_filter__3HyK5"};